import AiAskBarLandingVoiceActions from "./AiAskBarLandingVoiceActions";
import AiAskBarRightActionsDefault from "./AiAskBarRightActionsDefault";

export default function AiAskBarHomeComposerActions({
  vm,
  actions,
  sendDisabled,
  onVoiceToggle,
  voiceActive,
  landing,
}) {
  if (landing) {
    return (
      <AiAskBarLandingVoiceActions
        vm={vm}
        actions={actions}
        sendDisabled={sendDisabled}
        onVoiceToggle={onVoiceToggle}
      />
    );
  }

  return (
    <AiAskBarRightActionsDefault
      handleSend={actions.handleSend}
      sendDisabled={sendDisabled}
      sendIsActive={vm.sendIsActive}
      isSendPulsing={vm.isSendPulsing}
      onVoiceToggle={onVoiceToggle}
      voiceActive={voiceActive}
    />
  );
}
